import { X } from "lucide-react";
import { useState } from "react";
import { useFormContext } from "react-hook-form";

import { Button } from "../../../ui/button";
import { Dialog, DialogContent } from "../../../ui/dialog";

export const CloseDialogButton = ({
  onGoBack,
  onSubmit,
}: {
  onGoBack: () => void;
  onSubmit: () => void;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const form = useFormContext();

  return (
    <>
      <button
        aria-label="Close"
        className="focus-visible:ring-ring/50 absolute top-2.5 right-3 inline-flex items-center justify-center rounded-xs p-3 focus:outline-hidden focus-visible:ring-[3px]"
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.preventDefault();
          if (form.formState.isDirty) {
            setIsOpen(true);
          } else {
            onGoBack();
          }
        }}
        type="button"
      >
        <X className="text-foreground size-6" />
      </button>
      <Dialog onOpenChange={setIsOpen} open={isOpen}>
        <DialogContent className="max-w-lg">
          <div className="flex w-full">
            <div className="flex w-full flex-col items-center">
              <h1 className="h2 text-foreground w-fit leading-9">
                Changes not saved
              </h1>
              <h3 className="body text-muted-foreground mt-1 text-center">
                Are you sure you want to leave and discard changes to this item?
              </h3>

              <div className="mt-5 flex w-full space-x-3">
                <Button
                  className="w-full"
                  onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                    e.preventDefault();
                    setIsOpen(false);
                    onGoBack();
                  }}
                  variant="ghost"
                >
                  Discard Changes
                </Button>
                <Button
                  className="w-full"
                  onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                    e.preventDefault();
                    onSubmit();
                  }}
                >
                  Save Changes
                </Button>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
